import React from "react";
import "./About.css";
import { FaLinkedin, FaTwitter } from "react-icons/fa";
import { Helmet } from "react-helmet-async";


const About = () => {
  return (
    <div className="about-team-wrapper">

     <Helmet>
  <title>About Star Aluminium Works | Trusted Since 2014</title>
  <meta name="description" content="Learn about Star Aluminium Works, delivering aluminium and glass solutions since 2014 with quality, reliability, and expert craftsmanship." />
</Helmet>


      {/* ABOUT SECTION */}
      <section className="about-us">
        <div className="about-container">
          <h2>Your Trusted Partner for Premium Aluminium & Glass Solutions in Uttar Pradesh</h2>
          <p className="highlight">Our Commitment: Quality, Reliability, and Customer Satisfaction</p>
          <p>
           Star Aluminium Works is your trusted partner for premium aluminium and glass solutions across Uttar Pradesh. <span className="highlight-wo">Since 2014</span>, we have built a strong reputation for high-quality workmanship, reliable service, and complete customer satisfaction.
          </p>
Our goal is simple to deliver stylish, strong, and reliable solutions that enhance both residential and commercial spaces. From consultation to final installation, we focus on transparency, professionalism, and quality at every step.
         
          <p>
           We specialize in aluminium fabrication, glazing services, glass installation, partitions, windows, doors, and custom interior solutions. Every project is completed using high-grade materials, skilled craftsmanship, and modern techniques to ensure strength, durability, and long-term performance.
         At the heart of our success is our <span className="highlight-wo">CEO, Rehan Shaikh</span> a visionary leader with a strong focus on growth, innovation, and customer service. Under his guidance, Star Aluminium Works has grown into one of UP’s most respected and trusted names in the aluminium and glass industry. </p>
           
         
          <p className="contact">
            Ready to enhance your space? <strong>Contact Us Today!</strong>
          </p>
        </div>
      </section>

  

    </div>
  );
};

export default About;
